import { Directive, HostListener, Injector } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { QuerySolutionComponent } from "@gsp-cmp/querysolution";
@Directive({
  selector: "[farris-querysolution-event-bind]"
})
export class FarrisQuerySolutionEventBindDirective {
  constructor(private injector: Injector, private component: QuerySolutionComponent, private frameContext: FrameContext) { }
  /**
   * æ§è¡ç­é
   * @param event event
   */
  @HostListener("queryEmitter")
  private onQuery(event: any) {
    if (this.frameContext) {
      this.frameContext.repository.entityCollection.pageIndex = 1;
    }
  }
}